import{
ensureCorrectClass,
ponyfillCause,
setErrorName}from
"error-class-utils";









export default function errorCustomClass(name){
const CustomErrorClass=class extends Error{
constructor(message,parameters){
super(message,parameters);
ensureCorrectClass(this,new.target);
ponyfillCause(this,parameters)
}
};
setErrorName(CustomErrorClass,name);
return CustomErrorClass
}